var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  default: () => migrateDataSchema
});
module.exports = __toCommonJS(stdin_exports);
var import_omit = __toESM(require("lodash/omit"));
var import_keyBy = __toESM(require("lodash/keyBy"));
const typeSpecifiedKeys = [
  "items",
  "additionalFields",
  "fields",
  "groups",
  "default",
  "enum",
  "enumExpr",
  "example",
  "examples",
  "methods"
];
function migrateDataSchema(old, base, extraKeys = []) {
  if (old.type !== base.type) {
    const allTypeSpecifiedKeys = [...typeSpecifiedKeys, ...extraKeys];
    return Object.assign(Object.assign({}, (0, import_omit.default)(old, allTypeSpecifiedKeys)), base);
  }
  const ans = Object.assign(Object.assign({}, old), base);
  if (ans.type === "array" && old.items && base.items) {
    ans.items = migrateDataSchema(old.items, base.items, extraKeys);
  }
  if (ans.type === "object" && old.fields && base.fields) {
    const fieldsLUT = (0, import_keyBy.default)(old.fields, "id");
    ans.fields = base.fields.map((baseField) => {
      const oldField = fieldsLUT[baseField.id];
      if (!oldField)
        return baseField;
      return migrateDataSchema(oldField, baseField, extraKeys);
    });
  }
  return ans;
}
